import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { Head } from '../../common/utils/Head';
import breakpoints from '../../design-system/breakpoints';
import Colours from '../../design-system/colours';
import Variables from '../../design-system/variables';
import OvButton from '../UI/atoms/OvButton';
import OvLogo from '../UI/atoms/OvLogo';

const ErrorPage = () => {
  const { t } = useTranslation();

  return (
    <>
      <Head title={t('login.pageTitle')} description={t('login.pageDesc')} />
      <Container>
        <InfoBox role="alert">
          <OvLogo />
          <StyledErrorIcon />
          <InfoHeading>{t('errorPage.title')}</InfoHeading>
          <InfoDescription>{t('errorPage.description')}</InfoDescription>
          <StyledOvButton onClick={() => window.location.reload()}>
            {t('errorPage.reload')}
          </StyledOvButton>
          <StyledLink href="/">{t('errorPage.backToHome')}</StyledLink>
        </InfoBox>
      </Container>
    </>
  );
};

export default ErrorPage;

const Container = styled.main`
  background: ${Colours.WHITE};
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: ${Variables.boxShadow.alternateBox};
  padding: 3.875rem 2rem 2rem 2rem;

  @media (min-width: ${breakpoints.md}) {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate3d(-50%, -50%, 0);
    min-width: 30rem;
    max-width: 34rem;
    border-radius: 0.5rem;
  }
`;

const InfoBox = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  text-align: center;
`;

const StyledErrorIcon = styled(ErrorOutlineIcon)`
  && {
    margin-top: 2rem;
    color: ${Colours.OV_RED};
    font-size: 5rem;
  }
`;

const InfoHeading = styled.h1`
  color: ${Colours.OV_BASE};
  margin-bottom: 0.5rem;
`;

const InfoDescription = styled.p`
  color: ${Colours.OV_BASE};
  line-height: 1.5rem;
  margin: 0;
`;

const StyledOvButton = styled(OvButton)`
  && {
    border-radius: ${Variables.borderRadius.XLARGE};
    padding: 0.5rem 1.5rem;
    background-color: ${Colours.OV_BASE};
    margin: 1.5rem 0 1rem 0;
    text-transform: none;
    font-weight: bold;
  }
`;

const StyledLink = styled.a`
  color: ${Colours.OV_DARK_BLUE};
  font-size: 0.875rem;
`;
